var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import dayjs from 'dayjs';
var CLOCK_PERIODS = ['AM', 'PM'];
export var DEFAULT_TIME_SEGMENT_DELIMITER = ':';
export var DEFAULT_TIME_STRING_SEGMENT_DELIMITER = ' ';
export function formatTimeNumber(n) {
    return String(n).padStart(2, '0');
}
export function getTimePickerOptions(_a) {
    var use12HourClock = _a.use12HourClock, withSeconds = _a.withSeconds;
    var hours = [];
    var minutes = [];
    var seconds = [];
    var periods = [];
    if (use12HourClock) {
        hours.push(12);
        for (var i = 1; i < 12; i++)
            hours.push(i);
        CLOCK_PERIODS.forEach(function (period) { return periods.push(period); });
    }
    else {
        for (var i = 0; i < 24; i++)
            hours.push(i);
    }
    for (var i = 0; i < 60; i++)
        minutes.push(i);
    if (withSeconds) {
        for (var i = 0; i < 60; i++)
            seconds.push(i);
    }
    return { hours: hours, minutes: minutes, seconds: seconds, periods: periods };
}
export function getDisplayHourForDate(date, _a) {
    var isUTC = _a.isUTC, use12HourClock = _a.use12HourClock;
    var hour = isUTC ? date.getUTCHours() : date.getHours();
    if (use12HourClock) {
        hour = hour % 12;
        if (hour === 0)
            hour = 12;
    }
    return hour;
}
export function getDisplayMinuteForDate(date, _a) {
    var isUTC = _a.isUTC;
    return isUTC ? date.getUTCMinutes() : date.getMinutes();
}
export function getDisplaySecondForDate(date, _a) {
    var isUTC = _a.isUTC;
    return isUTC ? date.getUTCSeconds() : date.getSeconds();
}
export function getDisplayPeriodForDate(date, _a) {
    var isUTC = _a.isUTC;
    return (isUTC ? date.getUTCHours() : date.getHours()) >= 12 ? 'PM' : 'AM';
}
export function defaultFormatTime(date, _a) {
    var isUTC = _a.isUTC, use12HourClock = _a.use12HourClock, withSeconds = _a.withSeconds;
    return [
        [
            date && getDisplayHourForDate(date, { isUTC: isUTC, use12HourClock: use12HourClock }),
            date && getDisplayMinuteForDate(date, { isUTC: isUTC }),
            withSeconds && date && getDisplaySecondForDate(date, { isUTC: isUTC }),
        ]
            .map(function (x) { return typeof x === 'number' && formatTimeNumber(x); })
            .filter(function (x) { return x; })
            .join(DEFAULT_TIME_SEGMENT_DELIMITER)
            .trim(),
        use12HourClock && date && getDisplayPeriodForDate(date, { isUTC: isUTC }),
    ]
        .filter(function (x) { return x; })
        .join(DEFAULT_TIME_STRING_SEGMENT_DELIMITER)
        .trim();
}
export function getUpdatedDateForHour(hour, prevDate, _a) {
    var isUTC = _a.isUTC, use12HourClock = _a.use12HourClock;
    var newDate = null;
    if (prevDate) {
        newDate = new Date(prevDate.getTime());
        var derivedHour = hour;
        if (use12HourClock) {
            if ((isUTC ? prevDate.getUTCHours() : prevDate.getHours()) >= 12) {
                if (hour < 12)
                    derivedHour = hour + 12;
            }
            else if (hour === 12) {
                derivedHour = 0;
            }
        }
        if (isUTC) {
            newDate.setUTCHours(derivedHour);
        }
        else {
            newDate.setHours(derivedHour);
        }
    }
    else {
        newDate = new Date();
        var derivedHour = use12HourClock ? (hour === 12 ? 0 : hour) : hour;
        if (isUTC) {
            newDate.setUTCHours(derivedHour, 0, 0, 0);
        }
        else {
            newDate.setHours(derivedHour, 0, 0, 0);
        }
    }
    return newDate;
}
export function getUpdatedDateForMinute(minute, prevDate, _a) {
    var isUTC = _a.isUTC;
    var newDate = null;
    if (prevDate) {
        newDate = new Date(prevDate.getTime());
        if (isUTC) {
            newDate.setUTCMinutes(minute);
        }
        else {
            newDate.setMinutes(minute);
        }
    }
    else {
        newDate = new Date();
        if (isUTC) {
            newDate.setUTCHours(0, minute, 0, 0);
        }
        else {
            newDate.setHours(0, minute, 0, 0);
        }
    }
    return newDate;
}
export function getUpdatedDateForSecond(second, prevDate, _a) {
    var isUTC = _a.isUTC;
    var newDate = null;
    if (prevDate) {
        newDate = new Date(prevDate.getTime());
        if (isUTC) {
            newDate.setUTCSeconds(second);
        }
        else {
            newDate.setSeconds(second);
        }
    }
    else {
        newDate = new Date();
        if (isUTC) {
            newDate.setUTCHours(0, 0, second, 0);
        }
        else {
            newDate.setHours(0, 0, second, 0);
        }
    }
    return newDate;
}
export function getUpdatedDateForPeriod(period, prevDate, _a) {
    var isUTC = _a.isUTC;
    var newDate = null;
    if (prevDate) {
        newDate = new Date(prevDate.getTime());
        var prevHour = isUTC ? prevDate.getUTCHours() : prevDate.getHours();
        var newHour = prevHour;
        if (period === 'PM') {
            if (prevHour < 12)
                newHour = prevHour + 12;
        }
        else if (prevHour >= 12) {
            newHour = prevHour - 12;
        }
        if (isUTC) {
            newDate.setUTCHours(newHour);
        }
        else {
            newDate.setHours(newHour);
        }
    }
    else {
        newDate = new Date();
        var newHour = period === 'PM' ? 12 : 0;
        if (isUTC) {
            newDate.setUTCHours(newHour, 0, 0, 0);
        }
        else {
            newDate.setHours(newHour, 0, 0, 0);
        }
    }
    return newDate;
}
export function defaultParseTime(timeStr, _a) {
    var isUTC = _a.isUTC, use12HourClock = _a.use12HourClock, withSeconds = _a.withSeconds;
    var date = new Date();
    var segments = timeStr.trim().split(DEFAULT_TIME_STRING_SEGMENT_DELIMITER);
    var _b = __read((segments[0] || '').trim().split(DEFAULT_TIME_SEGMENT_DELIMITER), 3), hourStr = _b[0], minuteStr = _b[1], secondStr = _b[2];
    var hour = NaN;
    var minute = NaN;
    var second = NaN;
    if (hourStr) {
        hour = Number(hourStr);
        if (use12HourClock) {
            var period = segments[1];
            if (hour < 1 || hour > 12) {
                hour = NaN;
            }
            else if (period === 'AM') {
                if (hour === 12)
                    hour = 0;
            }
            else if (period === 'PM') {
                if (hour < 12)
                    hour += 12;
            }
            else {
                hour = NaN;
            }
        }
        else if (hour < 0 || hour > 23) {
            hour = NaN;
        }
    }
    if (minuteStr) {
        minute = Number(minuteStr);
        if (minute < 0 || minute > 59)
            minute = NaN;
    }
    if (withSeconds) {
        if (secondStr) {
            second = Number(secondStr);
            if (second < 0 || second > 59)
                second = NaN;
        }
    }
    else {
        second = 0;
    }
    if (isUTC) {
        date.setUTCHours(hour, minute, second, 0);
    }
    else {
        date.setHours(hour, minute, second, 0);
    }
    return dayjs(date).isValid() ? date : null;
}
